import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "components/Dialog";
import { RsWorkspaceEntityType } from "shared/types";
import { DIALOG_ACTION_TITLE } from "shared/labels";
import { setResultsRecalculationDialogOpen } from "store/rs-workspace/actions/rs-workspace.actions";
import { resultsRecalculationDialogOpenSelector } from "store/rs-workspace/selectors/results.selectors";
import * as styles from "./styles.module.scss";
const resultSetEntities = [
    RsWorkspaceEntityType.TabularView,
    RsWorkspaceEntityType.SpaceViewer,
    RsWorkspaceEntityType.ProcessDataViewer,
    RsWorkspaceEntityType.LineGraph,
];
const ResultRecalculationDialog = ({ entityType, onSubmit }) => {
    const dispatch = useDispatch();
    const dialogOpen = useSelector(resultsRecalculationDialogOpenSelector);
    const onCancelClick = useCallback(() => {
        dispatch(setResultsRecalculationDialogOpen(false));
    }, [dispatch]);
    const onSubmitClick = useCallback(async () => {
        dispatch(setResultsRecalculationDialogOpen(false));
        onSubmit();
    }, [dispatch, onSubmit]);
    return (React.createElement(Dialog, { isOpen: dialogOpen, title: `Changes to ${entityType}`, secondaryButtons: [{ onClick: onCancelClick, label: DIALOG_ACTION_TITLE.CANCEL }], primaryButton: { onClick: onSubmitClick, label: DIALOG_ACTION_TITLE.OK }, className: styles.dialog },
        React.createElement("div", { className: styles.info }, entityType && resultSetEntities.includes(entityType)
            ? `This ${entityType} is used in Calculations. If you save your changes, the Calculations will be stopped.`
            : `This ${entityType} is used in Calculations or calculated Results. If you save your changes, the
          Calculations will be stopped, and the Results must be re-calculated.`)));
};
export default ResultRecalculationDialog;
